var _a = require('optimism'), wrap = _a.wrap, defaultMakeCacheKey = _a.defaultMakeCacheKey; // tslint:disable-line
export { wrap, defaultMakeCacheKey };
//# sourceMappingURL=optimism.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-cache-inmemory/lib/optimism.js
// module id = null
// module chunks = 